import { render } from "./HeroElement.vue?vue&type=template&id=5cba6733"
import script from "./HeroElement.vue?vue&type=script&lang=js"
export * from "./HeroElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__